// src/pages/admin/AdminDashboard.jsx
import React, { useCallback, useContext, useEffect, useState } from "react";
import { MdPeople } from "react-icons/md";
import { GrCertificate } from "react-icons/gr";
import { PiShoppingCartSimpleThin } from "react-icons/pi";
import { CiBookmarkPlus } from "react-icons/ci";
import { StatsCard } from "../../../layouts/StatsCard";
import { DContext } from "../../../context/Datacontext";
import { useNavigate } from "react-router-dom";
import WeeklyCourseActivityChart from "./WeeklyCourseActivityChart";
import CreateCourseModal from "./CreateCourseModal";
import { fetchSyllbus } from "../../../services/coures/fetchSyllbus";
import  RecentOrderCourses  from '../instructor/RecentOrderCourses'

export const InstructorDashboard = () => {
  const { BeURL } = useContext(DContext);
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [departments, setDepartments] = useState([]);

  const [counts,setCounts] =useState(null)

      useEffect(() => {
        fetch(`${BeURL}/fetch-count-instructor`,{
              method: 'GET',
              credentials: 'include'
          })
              .then(res => res.json())
              .then(data => {
                  if (data.success) {
                      setCounts(data)
                  }
              })
              .catch(err => {
                  console.error('Error in fetch count', err);
              });
      }, [BeURL]);

  const fetchDepartments = useCallback(async () => {
    try {
      const res = await fetchSyllbus({ BeURL });
      if (res?.success) {
        setDepartments(res.departmentChips || []);
      }
    } catch (err) {
      console.error(err);
    }
  }, [BeURL]);

  useEffect(() => {
    fetchDepartments();
  }, [fetchDepartments]);

  return (
    <section className="py-5">
      <div className=" mx-auto px-4 space-y-6">
      {/* stat cards */}
      <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-3">
        <StatsCard
          title="Courses"
          count={counts?.data?.courseCount ?? 0}
          icon={<GrCertificate size={20} className="text-white" />}
          overlayClass="from-purple-400 to-pink-500"
          iconBg="bg-white/30"
            onClick={() => navigate("/instructor/mycourse")}
        />

        {/* <StatsCard
          title="Carts"
          count={counts?.data?.cartCount ?? 0}
          icon={<PiShoppingCartSimpleThin size={20} className="text-white" />}
          overlayClass="from-green-400 to-emerald-500"
          iconBg="bg-white/30"
          onClick={() => navigate("/app/carts")}
        /> */}

        <StatsCard
          title="Orders"
          count={counts?.data?.orderCount ?? 0}
          icon={<CiBookmarkPlus size={20} className="text-white" />}
          overlayClass="from-yellow-400 to-orange-500"
          iconBg="bg-white/30"
          onClick={() => navigate("/instructor/orders")}
        />

          <StatsCard
            title="Approved Courses"
            count={counts?.data?.approveCount ?? 0}
            icon={<MdPeople size={20} className="text-white" />}
            overlayClass="from-blue-400 to-indigo-600"
            iconBg="bg-white/30"
            onClick={() => navigate("/instructor/mycourse")}
          />
      </div>

      {/* main content area: chart + quick actions */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Chart card */}
        <div className="col-span-2 bg-white rounded-2xl p-6 shadow space-y-3">
          <h2 className="font-semibold text-xl">Course Activity</h2>
            <WeeklyCourseActivityChart/>
        </div>

        {/* Quick actions + top courses */}
        <aside className="space-y-6">
            <div className="bg-white rounded-2xl  space-y-6 p-6">
              <h3 className="text-lg font-semibold">Quick Actions</h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <button onClick={() => setOpenModal(true)} className="px-4 py-2 rounded-lg font-semibold border-secondary-300 bg-secondary-100 border hover:bg-secondary-200 text-secondary-600">Create Course</button>
                <button onClick={() => navigate("/instructor/my/profile")} className="px-4 py-2 rounded-lg font-semibold border-yellow-300 bg-yellow-100 border hover:bg-yellow-200 text-yellow-600">My Account</button>
              </div>
          </div>

            <div className="bg-white rounded-2xl  space-y-6 ">
              <RecentOrderCourses />
          </div>
            {/* <div className="bg-white rounded-2xl  space-y-6 ">
              <TopCourses />
          </div> */}
        </aside>
      </div>
    </div>
      <CreateCourseModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        departments={departments}
        onCreated={() => {
          setOpenModal(false);
          window.location.reload(); 
        }}
      />
    </section>
  );
};

